<template>
  <div v-bem>
    <h1>NotFound</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped lang="scss">
.not-found {
}
</style>